import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, Form, Button, Input, message } from "antd";

import storageUtils from "../../utils/storageUtils";
import { req_add_tqa_reviewOpinion } from "../../api";

const Item = Form.Item;
const { TextArea } = Input;
class ReviewSchoolOpinionAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    worker: PropTypes.object,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    worker: {},
    item: {
      WorkManualVersion: "",
      TagCode: "",
      ContentDescription: "",
      ContentUserCode: "",
      RecordStatus: "NEWDATA",
    },
  };

  constructor(props) {
    super(props);

    this.get_files = React.createRef();
    this.editor = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const result = await req_add_tqa_reviewOpinion(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    // console.log(this.props.bulletinboard)
    if (this.props.worker) {
      const worker = this.props.worker;
      this.setState({ worker });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (values) => {
    const { TagCode } = values;
    const { WorkManualVersion, AcademicYear, WorkTypeCode } = this.props.worker;
    const { ContentDescription } = this.state.item;
    const obj = {
      AcademicYear: AcademicYear,
      WorkTypeCode: WorkTypeCode,
      WorkManualVersion: WorkManualVersion,
      TagCode: TagCode,
      ContentDescription: ContentDescription,
      ContentUserCode: storageUtils.getUser().userCode,
    };
    //console.log("obj", obj);
    this.api_modify_item(obj);
  };

  handleChange = (values) => {
    // console.log(values)
    const { item } = this.state;
    Object.keys(item).forEach((propertyName) => {
      if (propertyName === "BlogType") {
        item[propertyName] = values;
      }
    });
    this.setState({ item });
  };

  onChangeTextArea = (e) => {
    console.log(e.target.value);
    const { item } = this.state;
    Object.keys(item).forEach((propertyName) => {
      if (e.target.id === propertyName && e.target.value !== null) {
        item[propertyName] = e.target.value.trim();
      }
    });
    this.setState({ item });
  };

  onChangeInput = (e, item) => {
    //console.log(e.target.value);
    this.setState({
      recordDescription: e.target.value,
    });
  };

  ///////////////////////////////////////////////////////////

  render() {
    const { TagCode, ContentDescription } = this.state.item;
    return (
      <Card>
        <Form onFinish={this.onFinish} onFinishFailed={this.onFinishFailed}>
          <Item
            label="頁碼"
            name="TagCode"
            initialValue={TagCode}
            rules={[{ whitespace: true, message: "頁碼" }]}
          >
            <Input placeholder="輸入頁碼" />
          </Item>
          <Item label="意見" name="ContentDescription">
            <TextArea
              rows={5}
              placeholder="最少5個字"
              id="ContentDescription"
              defaultValue={ContentDescription}
              allowClear
              onChange={(e) => this.onChangeTextArea(e)}
            />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" block>
              {"送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewSchoolOpinionAddModal);
